
import React from "react";
import { Box } from "@mui/material";
import Images from "../../assets";
import OrderSummaryTop from "../../components/general/orderConfirmation/orderSummaryTop";
import OrderItemsSection from "../../components/general/orderConfirmation/orderItemsSection";
import OrderDetailsSection from "../../components/general/orderConfirmation/orderDetailsSection";
import {useLocation} from "react-router";
import {useOrderConfirmation} from "../../hooks/thankYou/useOrderConfirmation";
import useUserData from "../../hooks/user/useUserData";


export default function ThankYou({response = null}) {
    const location = useLocation();
    const finalResponse = response ?? location.state?.response ?? null;
    const { language } = useUserData();
    const {
        orderHeader,
        orderItems,
        orderTotals,
        additionalInfoText,
        deliveryDetailsText,
        billingDetailsText,
        shippingDetailsText,
    } = useOrderConfirmation({
        finalResponse,
        language: language,
        paymentOptions: {
            "1": language === "en" ? "Cash on Delivery" : "Αντικαταβολή",
            "2": language === "en" ? "Bank Transfer" : "Τραπεζική κατάθεση",
            "3": language === "en" ? "Credit Card" : "Πιστωτική κάρτα",
            "4": language === "en" ? "Iris" : "Iris",
        },
    });

    return (
        <Box
            sx={{
                //bgcolor: "#F0F0F0",
                minHeight: "100vh",
                borderRadius:'30px',
                py: { xs: 1, md: 4 },
            }}
        >
            <Box
                sx={{
                    maxWidth: 1300,
                    mx: "auto",
                    px: { xs: 2, md: 2 },
                    display: "flex",
                    flexDirection: "column",
                    gap: { xs: 4, md: 6 },
                }}
            >
                <OrderSummaryTop orderHeader={orderHeader} />

                <OrderItemsSection
                    orderItems={orderItems}
                    orderTotals={orderTotals}
                />

                <OrderDetailsSection
                    additionalInfoText={additionalInfoText}
                    deliveryDetailsText={deliveryDetailsText}
                    billingDetailsText={billingDetailsText}
                    shippingDetailsText={shippingDetailsText}
                />
            </Box>
        </Box>
    );
}
